import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, TransitionGroup as _TransitionGroup, withCtx as _withCtx, createBlock as _createBlock, normalizeClass as _normalizeClass } from "vue";
const _hoisted_1 = { class: "grid w-full grid-cols-1 gap-7 xl:grid-cols-4 2xl:grid-cols-3" };
const _hoisted_2 = {
    key: 0,
    class: "flex grow flex-row gap-7 xl:col-span-3 2xl:col-span-2"
};
const _hoisted_3 = {
    key: "fullNavTransition-01",
    class: "w-full"
};
const _hoisted_4 = {
    key: "fullNavTransition-02",
    class: "flex w-full flex-col"
};
const _hoisted_5 = {
    key: 0,
    class: "mt-8 border-t border-white pt-8"
};
const _hoisted_6 = {
    key: "fullNavTransition-03",
    class: "w-full"
};
const _hoisted_7 = {
    key: "fullNavTransition-04",
    class: "w-full"
};
const _hoisted_8 = {
    key: 1,
    class: "hidden xl:block"
};
const _hoisted_9 = {
    key: 0,
    class: "flex flex-col"
};
const _hoisted_10 = ["href"];
const _hoisted_11 = { class: "text-sm font-bold" };
import DesktopNavLink from '@atoms/DesktopNavLink.vue';
import ImageLandscape from '@atoms/ImageLandscape.vue';
import ButtonWithArrow from '@atoms/ButtonWithArrow.vue';
import SecondaryNavigation from '@molecules/SecondaryNavigation.vue';
// Create a new object with sequential numeric keys because WP returns the nav item number as the key, so parents are not sequential
export default /*@__PURE__*/ _defineComponent({
    __name: 'DesktopFullScreenNavigation',
    props: {
        navOpen: {
            type: Boolean,
            required: false,
            default: false,
        },
        navigation: {
            type: Object,
            required: true,
        },
        secondaryNavigation: {
            type: Object,
            required: true,
        },
        japaneseText: {
            type: String,
            required: true,
        },
        japaneseLink: {
            type: Object,
            required: true,
        },
        featuredPost: {
            type: Object,
            required: true,
        },
    },
    setup(__props) {
        const props = __props;
        const sequentialNavigation = Object.keys(props.navigation).reduce((acc, key, index) => {
            acc[index + 1] = props.navigation[key];
            return acc;
        }, {});
        // Create a constant to remove the first 4 items
        const filteredNavigation = Object.fromEntries(Object.entries(sequentialNavigation).slice(4));
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", {
                "data-desktop-full-screen-navigation": "",
                class: _normalizeClass([{ 'grid-rows-1': __props.navOpen }, "hidden max-h-[calc(100vh-120px)] shrink grid-cols-1 grid-rows-0 text-white transition-all lg:grid"])
            }, [
                _createElementVNode("div", {
                    class: _normalizeClass([{ 'overflow-y-auto pt-14 !delay-0': __props.navOpen }, "container overflow-hidden px-10 transition-[padding] delay-100"])
                }, [
                    _createElementVNode("nav", _hoisted_1, [
                        _createVNode(_TransitionGroup, {
                            "enter-active-class": "slide-up__enter-active",
                            "enter-from-class": "slide-up__enter-from",
                            "enter-to-class": "slide-up__enter-to",
                            "leave-active-class": "slide-up__enter-active",
                            "leave-from-class": "slide-up__enter-to",
                            "leave-to-class": "slide-up__enter-from"
                        }, {
                            default: _withCtx(() => [
                                (__props.navOpen)
                                    ? (_openBlock(), _createElementBlock("ul", _hoisted_2, [
                                        (_unref(sequentialNavigation)[1])
                                            ? (_openBlock(), _createElementBlock("li", _hoisted_3, [
                                                _createVNode(DesktopNavLink, {
                                                    "nav-item": _unref(sequentialNavigation)[1]
                                                }, null, 8, ["nav-item"])
                                            ]))
                                            : _createCommentVNode("", true),
                                        (_unref(sequentialNavigation)[2])
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                                                _createElementVNode("li", null, [
                                                    _createVNode(DesktopNavLink, {
                                                        "nav-item": _unref(sequentialNavigation)[2]
                                                    }, null, 8, ["nav-item"])
                                                ]),
                                                (_unref(sequentialNavigation)[3])
                                                    ? (_openBlock(), _createElementBlock("li", _hoisted_5, [
                                                        _createVNode(DesktopNavLink, {
                                                            "nav-item": _unref(sequentialNavigation)[3]
                                                        }, null, 8, ["nav-item"])
                                                    ]))
                                                    : _createCommentVNode("", true)
                                            ]))
                                            : _createCommentVNode("", true),
                                        (_unref(sequentialNavigation)[4])
                                            ? (_openBlock(), _createElementBlock("li", _hoisted_6, [
                                                _createVNode(DesktopNavLink, {
                                                    "nav-item": _unref(sequentialNavigation)[4]
                                                }, null, 8, ["nav-item"])
                                            ]))
                                            : _createCommentVNode("", true),
                                        (_unref(filteredNavigation))
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(filteredNavigation), (navItem) => {
                                                    return (_openBlock(), _createElementBlock("li", {
                                                        key: navItem.objectID,
                                                        class: "mt-8 border-t border-white pt-8 first:mt-0 first:border-none first:pt-0"
                                                    }, [
                                                        _createVNode(DesktopNavLink, { "nav-item": navItem }, null, 8, ["nav-item"])
                                                    ]));
                                                }), 128))
                                            ]))
                                            : _createCommentVNode("", true)
                                    ]))
                                    : _createCommentVNode("", true),
                                (__props.navOpen)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                                        (__props.featuredPost)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                                                _createVNode(ImageLandscape, {
                                                    image: __props.featuredPost.image
                                                }, null, 8, ["image"]),
                                                _createElementVNode("a", {
                                                    href: __props.featuredPost.url,
                                                    class: "mb-3 mt-6 font-serif text-desktopNav 2xl:mb-7 2xl:mt-10"
                                                }, _toDisplayString(__props.featuredPost.title), 9, _hoisted_10),
                                                _createElementVNode("p", _hoisted_11, _toDisplayString(__props.featuredPost.date_range), 1),
                                                _createVNode(ButtonWithArrow, {
                                                    url: __props.featuredPost.url,
                                                    text: "Find out more",
                                                    class: "!text-white"
                                                }, null, 8, ["url"])
                                            ]))
                                            : _createCommentVNode("", true)
                                    ]))
                                    : _createCommentVNode("", true)
                            ]),
                            _: 1
                        })
                    ]),
                    (__props.secondaryNavigation)
                        ? (_openBlock(), _createBlock(SecondaryNavigation, {
                            key: 0,
                            "japanese-text": __props.japaneseText,
                            "japanese-link": __props.japaneseLink,
                            "nav-open": __props.navOpen,
                            navigation: __props.secondaryNavigation
                        }, null, 8, ["japanese-text", "japanese-link", "nav-open", "navigation"]))
                        : _createCommentVNode("", true)
                ], 2)
            ], 2));
        };
    }
});
